<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-chart-funnel`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.2781 1.73438C15.5177 1.7345 15.7393 1.86372 15.8572 2.07227C15.975 2.2808 15.9708 2.5369 15.8474 2.74219L8.57009 14.8359C8.44985 15.0357 8.23386 15.1581 8.00075 15.1582C7.76752 15.1582 7.55171 15.0357 7.43142 14.8359L2.55349 6.73047C2.47373 6.6531 2.41576 6.55533 2.38259 6.44629L0.154072 2.74219C0.0305463 2.53685 0.0264437 2.2809 0.144306 2.07227C0.262342 1.8638 0.483819 1.73438 0.723408 1.73438H15.2781ZM6.58083 10.8438L8.00075 13.2041L9.42067 10.8438H6.58083ZM5.78005 9.51367H10.074C10.1212 9.51369 10.1673 9.51895 10.2117 9.52832L11.783 6.91797H4.21852L5.78005 9.51367ZM3.41774 5.58789H12.5838L14.1023 3.06445H1.89919L3.41774 5.58789Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineChartFunnel',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
